export const getHeight = (sequencerEngine, showTracks={}) => {
    let height = 70 + 70 * ( 1 + sequencerEngine.subSequences.length);

    for (let id in showTracks) {
        if (showTracks[id]) {
            let subSequence = sequencerEngine.getSubSequence(id); 
            height += 85 * subSequence.tracks.length;
        }
    }
    return height;
};
